import { useState, useEffect } from "react";
interface OrderSuccessAnimationProps {
  orderId: string;
}
export const OrderSuccessAnimation = ({ orderId }: OrderSuccessAnimationProps) => {
  const [animationStep, setAnimationStep] = useState(0);
  useEffect(() => {
    const steps = [
      { delay: 0, step: 0 },
      { delay: 500, step: 1 },
      { delay: 1500, step: 2 },
      { delay: 2500, step: 3 }
    ];
    steps.forEach(({ delay, step }) => {
      setTimeout(() => setAnimationStep(step), delay);
    });
  }, []);
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-5">
      {/* Animated Success Icon */}
      <div className="relative mb-8">
        <div className={`w-32 h-32 rounded-full border-4 border-success flex items-center justify-center transition-all duration-1000 ${
          animationStep >= 1 ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
        }`}>
          <svg 
            className={`w-16 h-16 text-success transition-all duration-500 delay-500 ${
              animationStep >= 2 ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
            }`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={3} 
              d="M5 13l4 4L19 7"
              className={animationStep >= 2 ? 'animate-pulse' : ''}
            />
          </svg>
        </div>
        
        {/* Confetti Effect */}
        {animationStep >= 2 && (
          <div className="absolute inset-0 pointer-events-none">
            {[...Array(12)].map((_, i) => (
              <div
                key={i}
                className={`absolute w-2 h-2 bg-gradient-to-r from-secondary-yellow to-warning rounded-full animate-bounce`}
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 2}s`,
                  animationDuration: `${1 + Math.random()}s`
                }}
              />
            ))}
          </div>
        )}
      </div>
      {/* Success Message */}
      <div className={`text-center transition-all duration-1000 delay-1000 ${
        animationStep >= 3 ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      }`}>
        <h1 className="text-3xl font-bold text-black mb-4">
          Order Placed Successfully!
        </h1>
        <p className="text-lg text-gray-600 mb-6">
          Thank you for your purchase
        </p>
        
        {/* Order ID with Animation */}
        <div className="p-6 bg-white rounded-2xl shadow-lg border border-gray-100">
          <p className="text-sm text-gray-600 mb-2">Your Order ID</p>
          <p className="text-2xl font-bold text-primary-blue tracking-wider">
            {orderId}
          </p>
        </div>
        
        <p className="text-sm text-gray-500 mt-4">
          We&apos;ll send you updates about your order
        </p>
      </div>
      {/* Loading Dots */}
      <div className="flex gap-2 mt-8">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className={`w-3 h-3 bg-primary-blue rounded-full transition-all duration-300 ${
              animationStep >= 1 ? 'animate-pulse' : ''
            }`}
            style={{ animationDelay: `${i * 0.2}s` }}
          />
        ))}
      </div>
    </div>
  );
};